<!--nouvelle generation de grille avec kjlnhjk-->
<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="appellationsService"></yo-generic-datagrid-pn>
